import styled from "styled-components";
import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
    title: {
        "& .modal-title": {
            width: "100%",
            margin: "2rem 1.5rem 1rem 3.438rem",
        },
    },
}));

export const Action = styled.div`
    margin: 2.5rem 4.375rem;
    text-align: right;
    > button.MuiButton-root {
        margin-left: 2rem;
        margin-right: 0;
        min-width: 8.75rem;
        height: 2.625rem;
    }
    > button.MuiButton-root:hover {
        opacity: 0.75;
        box-shadow: none;
        background-color: ${globalThis.config.colors.black};
    }

    position: absolute;
    bottom: 0;
    right: 0;
`;

export const Content = styled.div`
    margin: auto 3.438rem;
    text-align: left;
    > p.MuiTypography-body1,
    button {
        font-weight: 700;
    }
    margin-bottom: 7.625rem;
`;

export const QuestionWrapper = styled.div`
    margin-top: 1.25rem;
    margin-bottom: 4rem;
    > p.MuiTypography-body1,
    button {
        font-weight: 700;
    }
`;
